/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';
import {
  OptionAwardService,
  PsuAwardService,
  RsuAwardService,
  type Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto,
  type Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto,
  type Wealthlane_AwardService_Dtos_BulkImport_PsuAwardImportResponseDto,
  // type Wealthlane_AwardService_Dtos_VestingTemplate_VestingImportResponseDTO,
  // VestingTemplateService,
} from '../../services/wealthlane-award-services';
import {
  ParticipantService,
  type Wealthlane_CustomerService_Dtos_Participant_ImportParticipantResponseDto,
} from '../../services/wealthlane-customer-services';

const usePostFileImport = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setImportedData: any,
  requestedModule: string,
  setImportStatus?: any,
  setCounter?: any
): UseMutationResult<
  | Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto
  | Wealthlane_AwardService_Dtos_BulkImport_PsuAwardImportResponseDto
  | Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto
  | Wealthlane_CustomerService_Dtos_Participant_ImportParticipantResponseDto
  // | Wealthlane_AwardService_Dtos_VestingTemplate_VestingImportResponseDTO
  | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      if (requestedModule.includes('RSU')) {
        return await handleRequest(
          RsuAwardService.postApiAwardApiAppRSUAwardValidateBulkRSu(payload)
        );
      } else if (requestedModule.includes('PSU')) {
        return await handleRequest(
          PsuAwardService.postApiAwardApiAppPSUAwardValidateBulkPSu(payload)
        );
      } else if (requestedModule.includes('Option')) {
        return await handleRequest(
          OptionAwardService.postApiAwardApiAppOptionAwardValidateBulkOptionAwards(payload)
        );
        // } else if (requestedModule.includes('VestingTemplate')) {
        //   return await handleRequest(
        //     VestingTemplateService.postApiAwardApiAppVestingTemplateValidateBulkImport(payload)
        //   );
      } else {
        // return await handleRequest(
        //   ParticipantService.postApiCustomerApiAppParticipantVerifyBulkParticipantsForImport(
        //     payload
        //   )
        //   // ParticipantService.postApiCustomerApiAppParticipantImportBulkParticipants(payload)
        // );
      }
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          // if (requestedModule !== 'RSU') {
          setImportedData(response?.id);
          setImportStatus(response);
          setCounter(1);
          // } else {
          //   setImportedData(response);
          // }
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostFileImport;
